export default __webpack_public_path__ + "static/media/compartilharPastaMenuNovo.8152af44.svg";